import * as React from 'react';

import {useFormContext, useWatch} from 'react-hook-form';

import _ from 'lodash';

export default function Form({onSubmit = undefined, onChange = undefined, children, ...props}) {

    const [formValues, setFormValues] = React.useState({});
    const {getValues, formState} = useFormContext();

    const currentValues = {
        ...useWatch(),
        ...getValues(),
    }

    if (onChange) {
        if (_.isEqual(currentValues,formValues) === false && formState.isDirty === true) {
            setFormValues(currentValues);
            onChange(currentValues);
        }
    }

    return (
        <form onSubmit={onSubmit} noValidate {...props}>
            {children}
        </form>
    )
}
